import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface FilaEtapa {
  contrato_id: string;
  status: string;
  quantidade: number;
  tempo_medio_horas: number;
  aging_3d: number;
  aging_7d: number;
  aging_15d: number;
  throughput_30d: number;
}

const STATUS_ORDER = [
  'em_apontamento',
  'aguardando_qualidade',
  'aguardando_planejamento',
  'disponivel_para_medicao',
  'vinculada_a_boletim',
];

const STATUS_LABELS: Record<string, string> = {
  em_apontamento: 'Apontamento',
  aguardando_qualidade: 'Qualidade',
  aguardando_planejamento: 'Planejamento',
  disponivel_para_medicao: 'Disp. Medição',
  vinculada_a_boletim: 'Vinculada',
  rejeitado: 'Rejeitado',
};

export const getStatusLabel = (s: string) => STATUS_LABELS[s] || s;

export function useWorkflowQueue(contratoId: string) {
  return useQuery({
    queryKey: ['emp-workflow-queue', contratoId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('emp_vw_fila_etapas' as any)
        .select('*')
        .eq('contrato_id', contratoId);
      if (error) throw error;
      const rows = (data || []) as unknown as FilaEtapa[];
      // Sort by workflow order
      return rows.sort((a, b) => {
        const ai = STATUS_ORDER.indexOf(a.status);
        const bi = STATUS_ORDER.indexOf(b.status);
        return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
      });
    },
    enabled: !!contratoId,
    staleTime: 60_000,
  });
}
